export default {
  PANEL_GO_BACK: 'All Products'
};
